import { MenuCotacaoItem } from "../components/menu-nova-cotacao/menu-nova-cotacao";

export const menuCotacao_new: MenuCotacaoItem[] = [
    {
        id: 1,
        titulo: "Automóvel",
        list: [
            {
                id: 11,
                txt: "Carro",
                icone: 'car-hatchback',
                url: '/cotacao/auto/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_auto',
                    label: 'Iniciando nova cotação Auto'
                }
            },
            {
                id: 12,
                txt: "Caminhão",
                icone: 'truck',
                url: '/cotacao/caminhao/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_caminhao',
                    label: 'Iniciando nova cotação Caminhão'
                }
            },
            {
                id: 13,
                txt: "Moto",
                icone: 'motorbike',
                url: '/cotacao/motocicleta/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_motocicleta',
                    label: 'Iniciando nova cotação Motocicleta'
                }
            },
        ]
    },
    {
        id: 2,
        titulo: "Compreensivos",
        list: [
            {
                id: 21,
                txt: "Residencial",
                icone: 'home',
                url: '/cotacao/residencial/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_residencial',
                    label: 'Iniciando nova cotação Residencial'
                }
            },
            {
                id: 22,
                txt: "Condomínio",
                icone: 'domain',
                url: '/cotacao/condominio/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_condominio',
                    label: 'Iniciando nova cotação Condomínio'
                }
            },
            {
                id: 23,
                txt: "Empresarial",
                icone: 'factory',
                url: '/cotacao/empresarial/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_empresarial',
                    label: 'Iniciando nova cotação Empresarial'
                }
            }
        ]
    },
    {
        id: 3,
        titulo: "Vida",
        list: [
            {
                id: 31,
                txt: "Vida Individual",
                icone: 'cards-heart',
                url: '/cotacao/vida/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_vida',
                    label: 'Iniciando nova cotação Vida'
                }
            },
            {
                id: 32,
                txt: "Vida Global",
                icone: 'vida-global',
                url: '/cotacao/vida_global/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_vida_global',
                    label: 'Iniciando nova cotação Vida Global'
                }
            },
            {
                id: 33,
                txt: "Acidentes Pessoais",
                icone: 'account-injury',
                url: '/cotacao/acidentes_pessoais/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_acidentes_pessoais',
                    label: 'Iniciando nova cotação Acidentes Pessoais'
                }
            },
            {
                id: 34,
                txt: "Viagem",
                icone: 'bag-suitcase',
                url: '/cotacao/viagem/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_viagem',
                    label: 'Iniciando nova cotação Viagem'
                }
            }
        ]
    },
    {
        id: 4,
        titulo: "Diversos",
        list: [
            {
                id: 41,
                txt: "Aluguel",
                icone: 'key-chain-variant',
                url: '/cotacao/aluguel/formulario',
                analytics: {
                    type: 'click',
                    category: 'aluguel',
                    label: 'Iniciando nova cotação Aluguel'
                }
            },
            {
                id: 42,
                txt: "Bike",
                icone: 'bicycle',
                url: '/cotacao/bike/formulario',
                analytics: {
                    type: 'click',
                    category: 'bike',
                    label: 'Iniciando nova cotação Bike'
                }
            }
        ]
    }
]

export const menuCotacao = [
    {
        titulo: 'Automóvel',
        url: '/cotacao/auto/formulario', 
        icone: 'car-hatchback',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_auto',
            label: 'Iniciando nova cotação Auto'
        }
    },
    {
        titulo: 'Caminhão', 
        url: '/cotacao/caminhao/formulario', 
        icone: 'truck',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_caminhao',
            label: 'Iniciando nova cotação Caminhão'
        }
    },
    {
        titulo: 'Moto', 
        url: '/cotacao/motocicleta/formulario', 
        icone: 'motorbike',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_motocicleta',
            label: 'Iniciando nova cotação Motocicleta'
        }
    },
    {
        titulo: 'Residencial', 
        url: '/cotacao/residencial/formulario', 
        icone: 'home',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_residencial',
            label: 'Iniciando nova cotação Residencial'
        }
    },
    {
        titulo: 'Condomínio', 
        url: '/cotacao/condominio/formulario', 
        icone: 'domain',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_condominio',
            label: 'Iniciando nova cotação Condomínio'
        }
    },
    {
        titulo: 'Empresarial', 
        url: '/cotacao/empresarial/formulario', 
        icone: 'factory',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_empresarial',
            label: 'Iniciando nova cotação Empresarial'
        }
    },
    {
        titulo: 'Vida', 
        url: '/cotacao/vida/formulario', 
        icone: 'cards-heart',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_vida',
            label: 'Iniciando nova cotação Vida'
        }
    },
    {
        titulo: 'Vida Global', 
        url: '/cotacao/vida_global/formulario', 
        icone: 'vida-global',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_vida_global',
            label: 'Iniciando nova cotação Vida Global'
        }
    },
    {
        titulo: 'Acidentes Pessoais', 
        url: '/cotacao/acidentes_pessoais/formulario', 
        icone: 'account-injury',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_acidentes_pessoais',
            label: 'Iniciando nova cotação Acidentes Pessoais'
        }
    },
    {
        titulo: 'Viagem', 
        url: '/cotacao/viagem/formulario', 
        icone: 'bag-suitcase',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_viagem',
            label: 'Iniciando nova cotação Viagem'
        }
    },
    {
        titulo: 'Aluguel', 
        url: '/cotacao/aluguel/formulario', 
        icone: 'key-chain-variant',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_aluguel',
            label: 'Iniciando nova cotação Aluguel'
        }
    },
    {
        titulo: 'Bike', 
        url: '/cotacao/bike/formulario', 
        icone: 'bicycle',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_bike',
            label: 'Iniciando nova cotação Bike'
        }
    }
];

export const menuPrincipal = [
    {
        titulo: 'Nova Cotação',
        url: '',
        icone: 'calculator',
        open: false,
        active: false,
        justMobile: true,
        justRoot: false,
        subList: menuCotacao
    },
    {
        titulo: 'Painel Administrativo',
        url: '/corretoras',
        icone: 'briefcase',
        open: false,
        active: false,
        justMobile: true,
        justRoot: true,
        subList: []
    },
    {
        titulo: 'Cotações', 
        url: '/cotacoes', 
        icone: 'view-list', 
        open: false,
        active: false,
        justMobile: false,
        justRoot: false,
        subList: []
    },
    {
        titulo: 'Dashboard', 
        url: '/dashboard', 
        icone: 'view-dashboard', 
        open: false,
        active: false,
        justMobile: false,
        justRoot: false,
        subList: []
    },
    {
        titulo: 'Tarefas', 
        url: '/lista-tarefas', 
        icone: 'menu-tarefas', 
        open: false,
        active: false,
        justMobile: false,
        justRoot: false,
        subList: []
    },
    {
        titulo: 'Negócios', 
        url: '', 
        icone: 'chart-areaspline-variant', 
        open: false,
        active: false,
        justMobile: false,
        justRoot: false,
        subList: [
            { titulo: 'Funil de Vendas',    url: '/funil-de-vendas', icone: 'funnel',        active: false, justAdmin: false  },
            { titulo: 'Lista de Negócios',  url: '/lista-negocios',  icone: 'cash-multiple', active: false, justAdmin: false  },
        ]
    },
    {
        titulo: 'Operacional',
        url: '',
        icone: 'cog',
        active: false,
        open: false,
        justMobile: false,
        justRoot: false,
        subList: [
            { titulo: 'Clientes',   url: '/clientes',   icone: 'account-group',         active: false, justAdmin: false },
            { titulo: 'Parcelas',   url: '/parcelas',   icone: 'currency-usd-off',      active: false, justAdmin: true },
            { titulo: 'Documentos', url: '/documentos', icone: 'file-download-outline', active: false, justAdmin: true  },
        ]
    },
    {
        titulo: 'Configurações',
        url: '/configuracoes',
        icone: 'tools',
        active: false,
        open: false,
        justMobile: true,
        justRoot: false,
        subList: []
    },
    {
        titulo: 'Suporte',
        url: '/suporte',
        icone: 'lifebuoy',
        open: false,
        active: false,
        external: false,
        justMobile: true,
        justRoot: false,
        subList: []
    }
];

export const menuReduzido = [
    {
        titulo: 'Configurações',
        url: '/configuracoes',
        icone: 'tools',
        active: false,
        open: false,
        justMobile: true,
        justRoot: false,
        subList: []
    },
    {
        titulo: 'Suporte',
        url: '/suporte',
        icone: 'lifebuoy',
        open: false,
        active: false,
        external: false,
        justMobile: true,
        justRoot: false,
        subList: []
    }
];